import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50fc4af9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "goods-info" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "关联设计方案", -1))
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "info-left" }
const _hoisted_5 = { class: "info-right" }
const _hoisted_6 = { class: "goods-name" }
const _hoisted_7 = { class: "goods-price" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-a-Group14379" }, null, -1))
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "goods-other" }
const _hoisted_11 = { class: "goods-price" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "原价", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-a-Group14379" }, null, -1))
const _hoisted_14 = { class: "goods-price-show" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("img", null, null, 512), [
          [_directive_lazy, _ctx.imgUrl(_ctx.goods.names, _ctx.goods.cover)]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.goods.names), 1),
        _createElementVNode("div", {
          class: "goods-other-price",
          style: _normalizeStyle({ color: _ctx.vipinfo.videocolor })
        }, [
          _createElementVNode("span", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", null, _toDisplayString(_ctx.getPrice()), 1)
          ]),
          (_ctx.vipinfo.type > 0 || _ctx.goods.activity_price > 0)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "viptype",
                src: _ctx.getPriceImg()
              }, null, 8, _hoisted_9))
            : _createCommentVNode("", true)
        ], 4),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, [
            _hoisted_12,
            _hoisted_13,
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.getOldPrice()), 1)
          ]),
          _createElementVNode("span", {
            class: "go-buy",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goto(_ctx.goods.id)))
          }, " 去购买 ")
        ])
      ])
    ])
  ]))
}